import React from 'react'
import { ContrastFormattedMessage } from '../../../../components/contrast-formatted-message'
import { ToggleSettingsItem } from '../../../../components/toggle-settings-item'

export interface RetainLibraryDataOrgSettingsToggleProps {
  readonly onToggle: (enabled: boolean) => void
  readonly enabled: boolean
}

export const RetainLibraryDataOrgSettingsToggleTestId = 'toggle-test-id'

export function RetainLibraryDataOrgSettingsToggle({
  onToggle,
  enabled
}: RetainLibraryDataOrgSettingsToggleProps) {
  return (
    <ContrastFormattedMessage id="title_retainLibraryData">
      {(title) => (
        <ContrastFormattedMessage id="detail_serversSettings_appliesToAllEnvironments">
          {(info) => (
            <ContrastFormattedMessage id="detail_retainLibraryData">
              {(description) => (
                <ToggleSettingsItem
                  title={title}
                  description={description}
                  info={info}
                  onToggle={onToggle}
                  enabled={enabled}
                  e2eId={'retain-library-data-toggle'}
                />
              )}
            </ContrastFormattedMessage>
          )}
        </ContrastFormattedMessage>
      )}
    </ContrastFormattedMessage>
  )
}
